import * as sharedTypes from 'src/actions/shared/sharedTypes';
import ivrsResource from 'src/actions/ivrs/ivrsResource';

export const validateCommentRequire: sharedTypes.AppThunk = (comment?: string) => dispatch => {
  const value = comment ? comment.trim() : '';
  if (!value) {
    dispatch(
      ivrsResource.actions.validationError([
        {
          attr: `comment`,
          code: `blank`,
          detail: 'Short description should not be empty.',
        },
      ])
    );
    return false;
  }

  return true;
};
